module.exports = __webpack_public_path__ + "img/resources-1440.852f7363.jpg";